import React, {FC} from 'react';
import MuiSlideTransition, {
    SlideDirection
} from '@material-ui/pickers/views/Calendar/SlideTransition';

interface SlideTransitionProps {
    transKey: React.Key;
    className?: string;
    slideDirection: SlideDirection;
    children: React.ReactChild;
    reduceAnimations?: boolean;
}

const SlideTransition: FC<SlideTransitionProps> = ({
    reduceAnimations,
    ...props
}: SlideTransitionProps) => {
    if (reduceAnimations) {
        return <div>{props.children}</div>;
    }

    return <MuiSlideTransition {...props} />;
};

export default SlideTransition;
